<template>
    <v-container grid-list-md>
        <v-card>
            <v-tabs fixed-tabs v-model="tab" color="brown" dark slider-color="red">
                <v-tab>Push-meldinger</v-tab>
                <v-tab>Annonser</v-tab>

                <v-tab-item>
                    <v-toolbar card>
                        <div class="headline">Push-meldinger</div>
                        <v-spacer/>
                        <v-btn color="green" dark :to="{name: 'CreateNotification'}">Ny melding</v-btn>
                    </v-toolbar>
                    <v-layout>
                        <v-flex md9 class="grey lighten-4 pl-0 ml-1 pt-0">
                            <v-list>
                                <v-list-tile three-line v-for="notification in notifications" :key="notification.id">
                                    <v-list-tile-avatar>
                                        <v-icon slot="activator" color="green darken-1" v-if="notification.recurrences">
                                            refresh
                                        </v-icon>
                                        <v-icon color="indigo" v-else>access_time</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ notification.title }}
                                            <small class="green--text text--darken-1" v-if="notification.recurrences">
                                                (sendes {{ notification.formatted_recurrences }})
                                            </small>
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>{{ notification.message }}</v-list-tile-sub-title>
                                    </v-list-tile-content>


                                    <v-btn flat color="primary"
                                           :to="{name: 'EditNotification', params: {id: notification.id}}">
                                        Rediger
                                    </v-btn>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-flex md3>
                            <push-history/>
                        </v-flex>
                    </v-layout>
                </v-tab-item>

                <v-tab-item>
                    <v-toolbar card>
                        <div class="headline">Annonser</div>
                        <v-spacer/>
                        <v-btn color="green" dark :to="{name: 'CreateBanner'}">Ny annonse</v-btn>
                    </v-toolbar>
                    <v-data-table :headers="bannerHeaders" :items="banners" hide-actions
                                  no-data-text="Ingen data funnet">
                        <template v-slot:items="props">
                            <td><strong>{{ props.item.title }}</strong></td>
                            <td>{{ dayjs(props.item.show_from).format('dddd D. MMMM YYYY HH:mm') }}</td>
                            <td>
                                <span v-if="props.item.show_until">
                                    {{ dayjs(props.item.show_until).format('dddd D. MMMM YYYY HH:mm') }}
                                </span>
                                <span v-else class="grey--text">Ingen utløpsdato</span>
                            </td>
                            <td>
                                <v-icon color="green" v-if="props.item.is_active">check</v-icon>
                                <v-icon color="red" v-else>close</v-icon>
                            </td>
                            <td style="width: 1px">
                                <v-btn flat color="primary" :to="{name: 'EditBanner', params: {id: props.item.id}}">
                                    Rediger
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
    import PushHistory from "../components/PushHistory";
    import axios from 'axios';
    import dayjs from "dayjs";
    import {rruleToText} from "../helpers";
    import RRule from "rrule";

    export default {
        components: {
            PushHistory
        },

        created() {
            this.loadData();
        },

        data() {
            return {
                tab: 0,
                loading: false,
                notifications: [],
                banners: []
            }
        },

        methods: {
            dayjs,
            loadData() {
                this.loading = true;

                let promises = [
                    axios.get('/api/notifications/').then(response => {
                        this.notifications = response.data.map(it => {
                            let formatted = '';
                            if (it.recurrences) {
                                formatted = rruleToText(RRule.fromString(it.recurrences));
                            }
                            return {
                                ...it,
                                formatted_recurrences: formatted
                            }
                        });
                    }),
                    axios.get('/api/banners/').then(response => {
                        this.banners = response.data;
                    })
                ];

                Promise.all(promises).finally(() => {
                    this.loading = false;
                })
            }
        },

        computed: {
            bannerHeaders() {
                return [
                    {text: 'Tittel', value: 'title'},
                    {text: 'Vises fra', value: 'show_from'},
                    {text: 'Vises til', value: 'show_until'},
                    {text: 'Synlig', value: 'is_active'},
                    {text: '', sortable: false}
                ]
            }
        }
    }
</script>
